import React from "react";
import "./dataConnectors.scss";

//Imagens:
import ImgDataConnectors from "../../../assets/connectors/dataConnectors.png";
import { useTranslation } from "react-i18next";

const DataConnectors = () => {
  const {t} = useTranslation()

  return (
    <div className="container-dataconnectors">
      <div className="texts-dataconnectors">
        <h1>{t("connectors.title")}</h1>
        <p>{t("connectors.section_text")}</p>
        <a href="/form">
          <span>
            <button id="btn-dataconnectors">{t("buttons.more_btn_text")}</button>
          </span>
        </a>
      </div>
      <div className="img-dataconnectors">
        <img src={ImgDataConnectors} alt="" />
      </div>
    </div>
  );
};

export default DataConnectors;
